const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the users tracks status component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 */
app.directive('userTracksStatus', ['Authorization', 'UserTracks', '$translate', function (Authorization, UserTracks, $translate) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-tracks-status.html'),
      controller: function () {
        var self = this;
        self.currentTab = 'active';

        self.findType = function(course) {
          return course.article ? 'article' : course.file ? 'file' : course.video ? 'video' : course.quiz ? 'quiz' : course.assessment ? 'assessment' : course.scorm ? 'scorm' : null;
        };

        var parseUserTracks = function(items) {
          var inProgress = [];
          var completedTracks = [];

          angular.forEach(items, function(uTrack) {
            if (!uTrack.track) {
              return;
            }
            if (uTrack.track.archived) {
              return;
            }
            var courses = 0;
            var completedCourses = 0; 
            var trackItems = {};

            if(uTrack.completed_date) {
              uTrack.completed_date_formatted = moment(new Date(uTrack.completed_date).toISOString()).format('MMM YYYY');
              completedTracks.push(uTrack);
              return;
            }

            if(!uTrack.completed_date) {
              angular.forEach(uTrack.track.sections, function(section) {
                angular.forEach(section.courses, function(course) {
                  var type = self.findType(course);
                  if (type) {
                    trackItems[course[type]] = true;
                    courses++;
                  }
                });
              });

              var c_assessments = uTrack.completed_assessments || [];
              var c_scorm = uTrack.completed_scorm || [];

              var completeList = [uTrack.completed_articles, uTrack.completed_media, uTrack.completed_quizzes, c_assessments, c_scorm];
              angular.forEach(completeList, function(list) {
                angular.forEach(list, function(id) {
                  if (trackItems[id] && trackItems[id] !== 1) {
                    completedCourses++;
                    trackItems[id] = 1;
                  }
                });
              });
              uTrack.progress = Math.ceil(completedCourses/courses * 100);

              if(uTrack.progress === 100 && uTrack.updatedAt) {
                completedTracks.push(uTrack);
                return;
              }
              inProgress.push(uTrack);
            }
          });
          self.inProgress = inProgress;
          self.completedTracks = completedTracks;
          self.loading = false;
        };

        self.initialize = function () {
          self.loading = true;
          UserTracks.find({
            fields: 'track,completed_articles,completed_media,completed_quizzes,completed_assessments,completed_scorm,completed_date,updatedAt',
            'track-populate': 'creator_name,name,description,sections.courses,topic,banner_image,archived',
            user: Authorization.getAuthToken().user._id
          }, function (data) {
            parseUserTracks(data);
            self.loaded = true;
            self.loading = false;
          }, function (error) {
            console.log('Error occured getting user Tracks ', error);
          });
        };
        $translate(['modules.notifications.unableToGetUserTracks']).then(function(data){
          self.translations = data;
          self.initialize();
        });
      },
      controllerAs: 'tracksStatus'
    };
  }]);
